export default __webpack_public_path__ + "48b26a6f68c4a74d630e699953e2a1cd.woff2";